import { render, staticRenderFns } from "./orderpayededit.vue?vue&type=template&id=c32fc8e4&scoped=true&"
import script from "./orderpayededit.vue?vue&type=script&lang=js&"
export * from "./orderpayededit.vue?vue&type=script&lang=js&"
import style0 from "./orderpayededit.vue?vue&type=style&index=0&id=c32fc8e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c32fc8e4",
  null
  
)

export default component.exports